import type { CodingContext } from '@imprivata-cloud/dataprivacy';
import { useMutation, useQuery } from '@tanstack/react-query';
import { addImprIdpDirectory, getImprIdpData } from '../../api/commonServices';
import type { DirectoryAddRequest, ImprDirectoriesConfig } from '../../api/types';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import type { AppError } from '../../errorHandler/errors';

export type AddDirectory = {
  addDirectoryRequest: DirectoryAddRequest;
  codingContext?: CodingContext;
};

const useAddImprIdpDirectory = (url: string) => {
  const { emitError } = useErrorContext();

  return useMutation({
    mutationFn: async (request: AddDirectory) => {
      return addImprIdpDirectory(url, request.addDirectoryRequest, request.codingContext || undefined);
    },
    onError: (error) => {
      emitError(error as AppError);
      console.log('Error saving Imprivata IDP Directory/Initial User', error);
    },
  });
};

const useDirectoriesConfig = (isSetup: boolean) => {
  return useQuery<ImprDirectoriesConfig | null>({
    queryKey: ['directories-config'],
    queryFn: async () => {
      const response = await getImprIdpData(isSetup);
      return response.directoriesConfig ?? null;
    },
  });
};

export { useAddImprIdpDirectory, useDirectoriesConfig };
